import { render, staticRenderFns } from "./PolicyWin.vue?vue&type=template&id=a1c3bb7e&scoped=true&"
import script from "./PolicyWin.vue?vue&type=script&lang=js&"
export * from "./PolicyWin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c3bb7e",
  null
  
)

export default component.exports